import React from "react";
import styles from "./InfoBox.scss";
import cx from "../../utils/cx";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import { Alert, AlertTitle } from "@mui/material";

export interface IInfoBoxProps {
  className?: string;
  title?: string;
}

const InfoBox: React.FC<React.PropsWithChildren<IInfoBoxProps>> = ({ className = '', children, title }) => {
    return <Alert severity="info" className={className}>
        { title && <AlertTitle>{title}</AlertTitle>}
        {children}
    </Alert>
};

export default InfoBox;
